import { jsx as _jsx } from "react/jsx-runtime";
const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        userSelect: 'none',
        width: '100%',
        height: '100%',
        paddingLeft: '2em',
        paddingRight: '2em',
    },
    text: {
        padding: '1.2em 2em',
        backgroundColor: '#f7f7f7',
        borderRadius: '2em',
        color: '#2d2d2d',
        fontWeight: 'bold',
    },
};
export function PanelNoData({ children }) {
    return (_jsx("div", { style: styles.container, children: _jsx("p", { style: styles.text, children: children }) }));
}
